import Spacing from './Spacing';

export default Spacing;
